import { render, staticRenderFns } from "./InsightCalculations.vue?vue&type=template&id=23fb3650&scoped=true&"
import script from "./InsightCalculations.vue?vue&type=script&lang=ts&"
export * from "./InsightCalculations.vue?vue&type=script&lang=ts&"
import style0 from "./InsightCalculations.vue?vue&type=style&index=0&id=23fb3650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb3650",
  null
  
)

export default component.exports